import CsAppBridge from './shared/CsAppBridge';

class LegalAppBridge extends CsAppBridge {

  static csToken;

  static init (environment, translator) {
    this.csToken = environment.getCsToken();
    return super.init(environment, translator);
  }

  static getCsToken () {
    return this.csToken;
  }
}

export default LegalAppBridge;
